import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { catchError } from 'rxjs';
import { GetAllSizeResponseModel } from 'src/app/components/administration/administration.model';
import { SendDataService } from '../../services/send-data.service';

@Component({
  selector: 'app-size',
  templateUrl: './size.component.html',
  styleUrls: ['./size.component.scss']
})
export class SizeComponent extends CommonService implements OnInit {
  isAdd                       : boolean = false;
  getAllSizeData              : any[]=[];

  copyGetAllSizeData          : any[]=[];
  editSizeData                = new GetAllSizeResponseModel();
  @ViewChild('administrationFormData') administrationFormData! : NgForm ;

constructor(
  public renderer:Renderer2,
  public administrationService : AdministrationService,
  public toaster: ToastrService,
  public sendDataService : SendDataService,
) 
{
  super(renderer)
}
ngOnInit(): void {
  this.getAllSizeList();
  }

add(){
  if(!this.sendDataService?.permissionVM?.mastersCanAdd) return; if(!this.sendDataService?.permissionVM?.mastersCanAdd) return;
  this.isAdd = true;
    const obj = {id:0, name:'',active:true}
    this.getAllSizeData?.push(obj); 
    this.copyGetAllSizeData?.push(obj);
    setTimeout(()=>{
      const element = document.getElementById(`Size${obj.id}`);
      element?.focus();
    },0)
}


cancel(){
  if(this.isAdd)
  {
    this.isAdd = false;
    this.getAllSizeData = this.getAllSizeData.filter((x)=>x.id != 0)
    this.copyGetAllSizeData = this.copyGetAllSizeData.filter((x)=>x.id != 0);
  }
  else if(this.editSizeData?.id && this.editSizeData?.isEdit){
    const index = this.copyGetAllSizeData.findIndex((x)=>x.id == this.editSizeData?.id);
    const singleData =JSON.parse(JSON.stringify(this.copyGetAllSizeData))[index];
    this.getAllSizeData[index] = singleData;
    this.editSizeData = new GetAllSizeResponseModel();
  }  
}

edit(item,formData){
  if(!this.sendDataService?.permissionVM?.mastersCanUpdate) return;
  item.isEdit = true;
  const controlObj = formData?.form?.controls;
  if(controlObj){
    const id = Object.keys(controlObj)[0];
    const element = document.getElementById(id);
    element?.focus();
  }
  this.editSizeData = {...item};
}


checkIsEdit(arr:any[]):boolean{
  return arr?.some((x)=>x.isEdit)
 }
 

    // *********** Size API START *********
    // **********get all Size *********
    getAllSizeList() {
      this.administrationService.getAllSize().subscribe({
        next:(res)=>{
          if(res.isSuccess){
            this.editSizeData = new GetAllSizeResponseModel();
            this.getAllSizeData = res.response??[];
            this.copyGetAllSizeData = JSON.parse(JSON.stringify(this.getAllSizeData))??[];
          }else{           
            this.getAllSizeData = []; 
            this.copyGetAllSizeData = [];
          }  
        },
        error:(err)=>{
          this.getAllSizeData = []; 
          this.copyGetAllSizeData = [];
        }
      })
    }

    // *************insert Size **************
       InserSizeList(item) {
        const {id , ...rest}= item;
        this.administrationService.insertSize(rest)
            .pipe(catchError((err) => this.handleError(err)))
            .subscribe((res) => {
              if(res.isSuccess){
                this.isAdd = false;
                this.getAllSizeList();
                this.toaster.success(res.message);
              }else{
                this.toaster.error(res.errors[0]);
              }  
          });
        }
    
    // **********update Size *********
    UpdateSizeList(item) {
      const {isEdit , ...rest} = item;
      this.administrationService.updateSize(rest)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if(res.isSuccess){
              this.isAdd = false;
              this.getAllSizeList();
              this.toaster.success(res.message);
            }else{
              this.toaster.error(res.errors[0]);
            }  
        });
      } 

      // **********delete Size *********
      DeleteSizeList(id) {
        if(!this.sendDataService?.permissionVM?.mastersCanDelete) return;
        this.administrationService.deleteSize(id)
            .pipe(catchError((err) => this.handleError(err)))
            .subscribe((res) => {
              if(res.isSuccess){
                this.getAllSizeList();
                this.toaster.success(res.message);
              }else{
                this.toaster.error(res.errors[0]);
              }  
        });
      }
}


